import { createSelector } from "@ngrx/store";
import { AppStore } from "../store";

export const selectUserState = (state: AppStore) => state.user;

export const getUserName = createSelector(
    selectUserState,
    (state) => state.email
);